import { render, staticRenderFns } from "./EditDiv.vue?vue&type=template&id=66c0120f&"
import script from "./EditDiv.vue?vue&type=script&lang=js&"
export * from "./EditDiv.vue?vue&type=script&lang=js&"
import style0 from "./EditDiv.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c0120f')) {
      api.createRecord('66c0120f', component.options)
    } else {
      api.reload('66c0120f', component.options)
    }
    module.hot.accept("./EditDiv.vue?vue&type=template&id=66c0120f&", function () {
      api.rerender('66c0120f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/components/EditDiv.vue"
export default component.exports